/**
 * Company: SPHMedia
 * Description: [Rating component]
 */

import RatingStar from "@assets/restaurant/rating.svg";
import { ReactElement } from "react";

type RatingProps = {
  rating: number;
};

/**
 * Rating
 * Description: [Displays rating with icon]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function Rating({ rating }: RatingProps): ReactElement {
  return (
    <div data-testid="restaurant-rating" className="flex items-center gap-1">
      <img src={RatingStar} alt="Rating Star" width={20} />
      <span className="text-black-700 font-semimedium text-sm leading-[150%]">
        {rating.toFixed(1)}
      </span>
    </div>
  );
}
